"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.encodeCode = void 0;
const uint8arrays_1 = require("@lit-protocol/uint8arrays");
/**
 * Encodes the given code string into base64 format.
 *
 * @param code - The code string to be encoded.
 * @returns The encoded code string in base64 format.
 */
const encodeCode = (code) => {
    const _uint8Array = (0, uint8arrays_1.uint8arrayFromString)(code, 'utf8');
    const encodedJs = (0, uint8arrays_1.uint8arrayToString)(_uint8Array, 'base64');
    return encodedJs;
};
exports.encodeCode = encodeCode;
//# sourceMappingURL=encode-code.js.map